(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_video-carousel-content"] && !Shopify.designMode) return;
  try {
    (function () {
  document.addEventListener('DOMContentLoaded', initSplides);
  document.addEventListener('shopify:section:load', initSplides);

  function initSplides() {
    document.querySelectorAll('.video-splide:not([data-splide-init])').forEach(function (el) {
      initSplide(el);
    });
  }

  function playSlideAutoplay(slide) {
    slide.querySelectorAll('deferred-media[autoplay] video').forEach(function (video) {
      video.play();
    });
    slide.querySelectorAll('deferred-media[autoplay] iframe').forEach(function (iframe) {
      var src = iframe.src || '';
      if (src.indexOf('youtube') !== -1) {
        iframe.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), '*'
        );
      } else if (src.indexOf('vimeo') !== -1) {
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
      }
    });
  }

  function pauseSlideVideos(slide) {
    slide.querySelectorAll('video').forEach(function (video) {
      video.pause();
    });
    slide.querySelectorAll('iframe').forEach(function (iframe) {
      var src = iframe.src || '';
      if (src.indexOf('youtube') !== -1) {
        iframe.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*'
        );
      } else if (src.indexOf('vimeo') !== -1) {
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
      }
    });
  }

  function patchYouTubeIframes(el) {
    // Patch iframes inside <template> (non-autoplay, user-initiated): just add enablejsapi
    el.querySelectorAll('template').forEach(function (tmpl) {
      tmpl.content.querySelectorAll('iframe').forEach(function (iframe) {
        var src = iframe.getAttribute('src') || '';
        if (src.indexOf('youtube') === -1) return;
        if (src.indexOf('enablejsapi') !== -1) return;
        var sep = src.indexOf('?') !== -1 ? '&' : '?';
        iframe.setAttribute('src', src + sep + 'enablejsapi=1');
      });
    });
    // Patch iframes already in the DOM (autoplay): add enablejsapi and strip autoplay
    // so the iframe reloads stopped instead of replaying
    el.querySelectorAll('iframe').forEach(function (iframe) {
      var src = iframe.getAttribute('src') || '';
      if (src.indexOf('youtube') === -1) return;
      var newSrc = src;
      if (newSrc.indexOf('enablejsapi') === -1) {
        var sep = newSrc.indexOf('?') !== -1 ? '&' : '?';
        newSrc = newSrc + sep + 'enablejsapi=1';
      }
      newSrc = newSrc.replace('autoplay=1', 'autoplay=0');
      if (newSrc !== src) iframe.setAttribute('src', newSrc);
    });
  }

  function initSplide(el) {
    var columns      = parseInt(el.dataset.columns, 10) || 1;
    var mobileCol    = parseInt(el.dataset.mobileColumns, 10) || 1;
    var gap          = parseInt(el.dataset.gap, 10) || 0;
    var loop         = el.dataset.loop === 'true';
    var withHints    = el.dataset.withHints === 'true';
    var arrowsStyle  = el.dataset.arrows;
    var pagination   = el.dataset.pagination;

    var showArrows   = arrowsStyle && arrowsStyle !== 'none';
    var showDots     = pagination === 'dots';
    var showCounter  = pagination === 'counter';

    var padding = withHints
      ? { left: '20vw', right: '20vw' }
      : 0;

    var slideCount = el.querySelectorAll('.splide__list > li').length;
    if (slideCount < 2) {
      loop = false;
      showArrows = false;
    }

    var splide = new Splide(el, {
      type        : loop ? 'loop' : 'slide',
      perPage     : columns,
      perMove     : 1,
      gap         : gap + 'px',
      padding     : padding,
      focus       : withHints ? 'center' : false,
      trimSpace   : !withHints,
      drag        : slideCount > 1,
      arrows      : showArrows,
      pagination  : showDots,
      breakpoints : {
        749: {
          perPage : mobileCol,
          gap     : '16px',
          padding : withHints
            ? { left: '10vw', right: '10vw' }
            : 0,
        },
      },
      i18n: {
        prev       : "{{ 'accessibility.slideshow_previous' | t }}",
        next       : "{{ 'accessibility.slideshow_next' | t }}",
        carousel   : "{{ 'accessibility.slideshow' | t }}",
        slide      : "{{ 'accessibility.slideshow' | t }}",
        slideLabel : '%s/%s',
      },
    });

    splide.on('mounted', function () {
        patchYouTubeIframes(el);
        el.querySelectorAll('.splide__slide').forEach(pauseSlideVideos);
        var realSlides = el.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
        var active = realSlides[splide.index];
        if (active) playSlideAutoplay(active);
    });

    splide.on('move', function () {
      el.querySelectorAll('.splide__slide').forEach(pauseSlideVideos);
    });

    splide.on('moved', function () {
        var realSlides = el.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
        var active = realSlides[splide.index];
        if (active) playSlideAutoplay(active);
    });

    if (showCounter) {
      var counter = document.createElement('div');
      counter.className = 'splide__counter';
      counter.setAttribute('role', 'status');
      counter.setAttribute('aria-live', 'polite');
      counter.setAttribute('aria-atomic', 'true');
      splide.on('mounted move', function () {
        var total = splide.Components.Controller.getEnd() + 1;
        var index = splide.index + 1;
        counter.textContent = index + ' / ' + total;
      });
      splide.on('mounted', function () {
        el.appendChild(counter);
      });
    }

    el.addEventListener('play', function (e) {
      if (e.target.tagName === 'VIDEO' && !e.target.closest('deferred-media[autoplay]')) {
        e.target.muted = false;
      }
    }, true);

    splide.mount();
    el.setAttribute('data-splide-init', '');
  }
})();
  } catch(e) { console.error(e); }
})();

})();
